import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sign-rectangle',
  templateUrl: './sign-rectangle.component.html',
  styleUrls: ['./sign-rectangle.component.scss']
})
export class SignRectangleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
